/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  ERC1155PresetMinterPauserSupplyHolder,
  ERC1155PresetMinterPauserSupplyHolderInterface,
} from "../ERC1155PresetMinterPauserSupplyHolder";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "uri",
        type: "string",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "burnBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mintBatch",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ERC1155PresetMinterPauserSupplyHolderConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ERC1155PresetMinterPauserSupplyHolderConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class ERC1155PresetMinterPauserSupplyHolder__factory extends ContractFactory {
  constructor(...args: ERC1155PresetMinterPauserSupplyHolderConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ERC1155PresetMinterPauserSupplyHolder> {
    return super.deploy(
      uri,
      overrides || {}
    ) as Promise<ERC1155PresetMinterPauserSupplyHolder>;
  }
  getDeployTransaction(
    uri: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(uri, overrides || {});
  }
  attach(address: string): ERC1155PresetMinterPauserSupplyHolder {
    return super.attach(address) as ERC1155PresetMinterPauserSupplyHolder;
  }
  connect(signer: Signer): ERC1155PresetMinterPauserSupplyHolder__factory {
    return super.connect(
      signer
    ) as ERC1155PresetMinterPauserSupplyHolder__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ERC1155PresetMinterPauserSupplyHolderInterface {
    return new utils.Interface(
      _abi
    ) as ERC1155PresetMinterPauserSupplyHolderInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155PresetMinterPauserSupplyHolder {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ERC1155PresetMinterPauserSupplyHolder;
  }
}
